module.exports = __webpack_public_path__ + "static/satoshidice-logo-e6be07529dc574d21d79d76ab0d0740d.png";